import React from 'react';
import '../css/footer.css';
import Config from '../config/Config';
let baseRoutePath = Config.getBaseRoutePath();
class Footer extends React.Component {
  render() {
    return (
      <footer className="footer">
        <div className="footer-top">
       

          <div className='a-footer__bottom'>
            <div className='footer__content'>
              <div className='footer__info'>
                <a href={baseRoutePath + '/license/1'} target='_blank' className='link'>人力资源服务许可证</a>
                <em className='separator'></em>
                <a href={baseRoutePath + '/license/2'} target='_blank' className='link'>营业执照</a>
                <em className='separator'></em>
                <a href={baseRoutePath + '/license/3'} target='_blank' className='link'>增值电信业务经营许可证：浙B2-20261037</a>
              </div>
              <div className='footer__copyright'>
                <span>Copyright © 2026 聘准准</span>
                <em className='separator'></em>
                <a href='https://beian.miit.gov.cn/' target='_blank' rel='noopener noreferrer' className='link'>浙ICP备2024111167号-1</a>
              </div>
            </div>
          </div>

        </div>


      </footer>
    );
  }
}

export default Footer;
